export default {
  "pl": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Zmień obraz na stronie logowania",
        "new": "Nowy klient",
        "submit": "Prześlij",
        "undoChanges": "Cofnij zmiany"
      },
      "attributes": {
        "address": "Adres",
        "backgroundImage": "Obraz na stronie logowania",
        "email_address": "E-mail",
        "email_address_reply_to": "Adres e-mail „Odpowiedz”",
        "email_address_ziggu": "\"Z adresu email",
        "iban": "IBAN",
        "language": "Język",
        "name": "Nazwa",
        "phone": "Numer telefonu",
        "storage_sum": "Wykorzystane miejsce",
        "storage_sum_max": "Wykorzystujesz obecnie {percentage}% dostępnego miejsca z {gigabytes} GB",
        "subdomain": "Subdomena",
        "vat_number": "Numer VAT"
      },
      "labels": {
        "activeUnits": "aktywnych jednostek",
        "activeUnitsUsed": "{0} jednostek aktywnych, {1} pozostałych",
        "by": "Projekt klienta: {client}",
        "companyProfile": "Profil firmy",
        "contactIntercom": "Jeśli chcesz wprowadzić zmiany, skontaktuj się z nami za pośrednictwem czatu.",
        "email_address_reply_to": "Ten adres e-mail zostanie użyty, jeśli ktoś odpowie na wiadomość e-mail wysłaną przez {email_address_ziggu}. Skontaktuj się z nami za pośrednictwem czatu, jeśli chcesz to zmienić.",
        "email_address_ziggu": "Ten adres e-mail będzie używany jako adres FROM wszystkich wiadomości e-mail wysyłanych za pośrednictwem platformy (e-maile dotyczące powiadomień, zaproszeń, resetowania hasła, ...)",
        "general": "Ogólne",
        "goToSettings": "Ustawienia",
        "invoice_overdue": "Masz jedną spóźnioną płatność. Aby uzyskać więcej informacji, skontaktuj się z nami pod adresem accounting@ziggu.io",
        "language": "To jest domyślny język firmy, który będzie wykorzystywany na stronie logowania oraz w przypadku klientów i członków zespołu.",
        "mustBeJPG": "Obraz musi być w formacie JPG",
        "other": "Inne",
        "outOfOffice": "Poza biurem",
        "outOfOfficeMessage": "Wiadomość „Poza biurem” (opcjonalnie)",
        "packageUnits": "Zawarte w pakiecie",
        "removed_user": "Usunięto użytkownika",
        "settings": {
          "click_to_copy": "Kliknij, aby skopiować token do schowka",
          "copied_to_clipboard": "Token skopiowany do schowka"
        },
        "subscription": "Subskrypcja",
        "subscriptionRenewalDate": "Subskrypcja z datą",
        "subscriptionUsageUnits": "obecne zużycie",
        "tab_aftercare": "Opieka postpenitencjarna",
        "tab_information": "Informacja",
        "tab_integrations": "Integracje",
        "timezone": "To domyślna strefa czasowa firmy.",
        "upgradePackageContactUs": "Skontaktuj się z nami, aby rozpocząć",
        "upgradePackageSubtitleAftercare": "Ta funkcja umożliwi Ci kontakt z klientami po dostawie i pomoże im rozwiązać wszelkie problemy związane z ich nowym domem",
        "upgradePackageSubtitleConversationMentions": "Ta funkcja umożliwi Ci pisanie prywatnych notatek i oznaczanie członków zespołu w rozmowie",
        "upgradePackageSubtitleFinancials": "Błyskawicznie stwórz zestawienie finansowe dla każdego kupującego",
        "upgradePackageSubtitleMilestones": "Cette fonctionnalité vous permet de communiquer facilement l'avancement de la construction à votre client",
        "upgradePackageSubtitleMultipleCustomerSingleUnit": "Ta funkcja umożliwi Ci zaproszenie drugiego kupującego na platformę Ziggu",
        "upgradePackageTitle": "Wygląda na to, że nie masz jeszcze tej funkcji"
      },
      "validation": {
        "mustBeEmailAddress": "Należy podać adres e-mail",
        "needName": "Należy podać nazwę"
      }
    }
  }
}
